import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { TrendingUp, Shield, Percent } from 'lucide-react';

const WhyBali = () => {
  const { t } = useLanguage();

  const advantages = [
    {
      icon: TrendingUp,
      title: t('whyBali.cards.yields.title'),
      subtitle: t('whyBali.cards.yields.subtitle'),
      description: t('whyBali.cards.yields.description'),
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: Shield,
      title: t('whyBali.cards.growth.title'),
      subtitle: t('whyBali.cards.growth.subtitle'),
      description: t('whyBali.cards.growth.description'),
      image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=800&q=80'
    },
    {
      icon: Percent,
      title: t('whyBali.cards.tax.title'),
      subtitle: t('whyBali.cards.tax.subtitle'),
      description: t('whyBali.cards.tax.description'),
      image: 'https://images.unsplash.com/photo-1555400038-63f5ba517a47?auto=format&fit=crop&w=800&q=80'
    }
  ];

  return (
    <section className="section-padding bg-[#FDFCFA]" data-testid="why-bali-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4">{t('whyBali.overline')}</p>
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl text-[#1A1A2E] font-semibold mb-6">
            {t('whyBali.title')}
          </h2>
          <p className="text-[#4A4A5A] max-w-2xl mx-auto">
            {t('whyBali.subtitle')}
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {advantages.map((item, index) => (
            <div
              key={index}
              className="group card-light rounded-2xl overflow-hidden transition-all duration-500"
              data-testid={`advantage-card-${index}`}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent" />
                
                {/* Badge */}
                <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-sm shadow-sm">
                  <span className="text-[#C9A227] text-xs font-semibold">{item.subtitle}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="w-12 h-12 rounded-xl icon-gold flex items-center justify-center mb-4 transition-all">
                  <item.icon className="w-5 h-5 text-[#C9A227]" />
                </div>
                
                <h3 className="text-xl font-playfair text-[#1A1A2E] font-semibold mb-3">
                  {item.title}
                </h3>
                
                <p className="text-[#4A4A5A] text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyBali;
